// Smooth scroll to Tech Specs section on button click
document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".specs-grid__button");
  if (button) {
    button.addEventListener("click", function (event) {
      event.preventDefault();
      const target = document.querySelector(".section-tech-spec");
      if (target) {
        // Get the header height dynamically if possible, or use a fallback
        const header =
          document.querySelector(".header-wrapper") ||
          document.querySelector("header");
        const headerOffset = header ? header.offsetHeight : 0;
        const additionalOffset = 20; // Extra breathing room

        const elementPosition = target.getBoundingClientRect().top;
        const offsetPosition =
          elementPosition +
          window.pageYOffset -
          headerOffset -
          additionalOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  }
});
